import { Component, computed, inject, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { mgcIconAlertCuteRe } from '@sb/mgc-icons/mgcIcon-alert_cute_re.icon';
import { mgcIconCheckCircleCuteRe } from '@sb/mgc-icons/mgcIcon-check_circle_cute_re.icon';
import { mgcIconLockRegular } from '@sb/mgc-icons/mgcIcon-lock_regular.icon';
import { mgcIconUserAddCuteRe } from '@sb/mgc-icons/mgcIcon-user_add_cute_re.icon';
import { BadgeComponent, type badgeThemePalette } from '@sb/ui/badge';
import { ButtonComponent } from '@sb/ui/button';
import { DashboardWidgetModule } from '@sb/ui/dashboard-widget/dashboard-widget.module';
import { EmptyStateComponent, LoadingStateComponent } from '@sb/ui/feedback';
import { IconComponent, IconRegistry } from '@sb/ui/icon';

export type DecisionListState = 'locked' | 'ready' | 'loading' | 'error' | 'clear';

@Component({
  selector: 'decision-list-widget',
  templateUrl: './decision-list-widget.component.html',
  imports: [
    DashboardWidgetModule,
    BadgeComponent,
    ButtonComponent,
    IconComponent,
    LoadingStateComponent,
    TranslatePipe,
    EmptyStateComponent,
  ],
})
export class DecisionListWidgetComponent {
  title = input.required<string>();
  state = input.required<DecisionListState>();
  badgeLabel = input<string>('');
  clearMessage = input<string>('');
  errorMessage = input<string>('');
  scopeLocation = input<string | null>(null);

  retry = output<void>();
  unlock = output<void>();

  badge = computed((): { label: string; color: badgeThemePalette; isLocked: boolean } | null => {
    switch (this.state()) {
      case 'locked':
        return { label: '', color: 'grey', isLocked: true };
      case 'clear':
        return { label: this.badgeLabel(), color: 'green', isLocked: false };
      case 'ready':
        return { label: this.badgeLabel(), color: 'red', isLocked: false };
      case 'loading':
      case 'error':
        return null;
    }
  });

  constructor() {
    inject(IconRegistry).registerIcons([
      mgcIconLockRegular,
      mgcIconCheckCircleCuteRe,
      mgcIconUserAddCuteRe,
      mgcIconAlertCuteRe,
    ]);
  }
}
